module.exports = __webpack_public_path__ + "static/media/ccu_mis_logo.52e4e922.png";